import $ from 'jquery';
import { colorProducts } from '../../data/color-products-data.js';

class ColorProductModal {
	constructor() {
		this.$modal = $('#modal-color-product');
		if (!this.$modal.length) return;

		this.$backdrop = this.$modal.find('.modal__backdrop');
		this.$closeBtn = this.$modal.find('.modal__close');
		this.currentProduct = null;

		this.init();
	}

	// HTMLタグを除去するヘルパーメソッド
	stripHtmlTags(str) {
		if (!str) return '';
		return str.replace(/<[^>]*>/g, '');
	}

	init() {
		// カードクリックイベント
		$('.products_items_card[data-product-id]').on('click', (e) => {
			const productId = $(e.currentTarget).data('product-id');
			this.openModal(productId);
		});

		// 閉じるボタン
		this.$closeBtn.on('click', () => this.closeModal());

		// 背景クリック
		this.$backdrop.on('click', () => this.closeModal());

		// ESCキー
		$(document).on('keydown', (e) => {
			if (e.key === 'Escape' && this.$modal.hasClass('is-active')) {
				this.closeModal();
			}
		});

		// 外部モジュール（labo-modal 等）からの起動リクエスト
		window.addEventListener('openColorProductModal', (e) => {
			const productId = e.detail?.productId;
			if (productId) this.openModal(productId);
		});
	}

	openModal(productId) {
		const product = colorProducts.find(p => p.id === productId);
		if (!product) return;

		this.currentProduct = product;
		this.renderModal(product);

		// モーダルのスクロール位置を最上部にリセット
		this.$modal.find('.modal-color-product_body').scrollTop(0);

		// フェードインアニメーション
		$('body').css('overflow', 'hidden');

		// 2回のrequestAnimationFrameで確実にレンダリングを待つ
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.$modal.addClass('is-active');
			});
		});
	}

	closeModal() {
		// フェードアウトアニメーション
		this.$modal.removeClass('is-active');

		// アニメーション完了後にbodyのスクロールを復元
		setTimeout(() => {
			$('body').css('overflow', '');
		}, 300); // transitionの時間と同じ
	}

	renderModal(product) {
		// 画像
		this.$modal.find('.modal-color-product_lips-img').attr('src', product.images.lips);
		this.$modal.find('.modal-color-product_lips-img').attr('alt', this.stripHtmlTags(product.name));
		this.$modal.find('.modal-color-product_paste-img').attr('src', product.images.paste);
		this.$modal.find('.modal-color-product_paste-img').attr('alt', this.stripHtmlTags(product.name));

		// NEWアイコン
		const $newBadge = this.$modal.find('.modal-color-product_new');
		if (product.newIcon) {
			$newBadge.find('img').attr('src', product.newIcon);
			$newBadge.show();
		} else {
			$newBadge.hide();
		}

		// 商品名
		this.$modal.find('.modal-color-product_name').html(product.name);

		// SPFとタグ
		this.$modal.find('.modal-color-product_spf').text(product.spf);
		this.$modal.find('.modal-color-product_tag').text(product.tag);

		// 価格
		this.$modal.find('.modal-color-product_price-amount').text(product.price);

		// メインコピー
		this.$modal.find('.modal-color-product_copy').html(product.mainCopy);

		// 説明文
		this.$modal.find('.modal-color-product_description').html(product.description);

		// バッジ
		const $badgesContainer = this.$modal.find('.modal-color-product_badges');
		$badgesContainer.empty();
		product.badges.forEach(badge => {
			$badgesContainer.append(`<span class="badge">${badge}</span>`);
		});

		// カラーチャート画像
		const chartImage = product.colorChart || './assets/images/products/color/chart.webp';
		this.$modal.find('.modal-color-product_chart-image img').attr('src', chartImage);

		// カラーチャートマーカー位置
		if (product.colorChart && product.colorChart.position) {
			const $marker = this.$modal.find('.modal-color-product_chart-marker');
			$marker.css({
				'left': product.colorChart.position.x,
				'top': product.colorChart.position.y
			});
		}
	}
}

$(() => {
	new ColorProductModal();
});

export default ColorProductModal;
